import { useState, useEffect } from "react";
import { convertPxToRem } from "frontend/components/helpers";

/**
 * Windows and Mac (and perhaps others) have differnt UI dims for ScrollBar
 * This leverages 15 by default, but then does a check based
 * on current UI for more precise measurement
 * Curerently used in Header Modals to account for scrollBars
 * @returns {Number} scrollbarWidth
 */
export const useScrollBarWidth = () => {
    const [scrollbarWidth, setScrollbarWidth] = useState(15);

    // Mount a temp div with scrollbar to DOM
    // to measure the scrollbar width
    // Then remove from DOM
    useEffect(() => {
        let div = document.createElement("div");
        div.style.width = "100px";
        div.style.height = "100px";
        div.style.overflow = "scroll";
        document.body.appendChild(div);
        setScrollbarWidth(div.offsetWidth - div.clientWidth);
        document.body.removeChild(div);
    }, []);

    return {
        scrollbarWidth,
        scrollbarWidthRem: convertPxToRem(scrollbarWidth)
    };
};
